import { Box, CircularProgress, Fade } from "@mui/material"
import { ReactElement } from "react"

import { FILTER_PANEL_SLIDE_MS } from "../../../constants/generalConstants"
import { TT_REVALIDATING } from "../../../constants/tooltips"
import AppTooltip from "../../helper/appTooltip"

interface IRevalidatingSpinnerProps {
    isValidating: boolean
}

/**
 * Reusable spinner for when data is being revalidated via the SWR hook
 */
const RevalidatingSpinner = ({
    isValidating,
}: IRevalidatingSpinnerProps): ReactElement => (
    <Fade
        in={isValidating}
        timeout={FILTER_PANEL_SLIDE_MS}
        mountOnEnter
        unmountOnExit
    >
        <Box>
            <AppTooltip title={TT_REVALIDATING}>
                <CircularProgress size={20} sx={{ mt: 1 }} />
            </AppTooltip>
        </Box>
    </Fade>
)
export default RevalidatingSpinner
